'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;

    this.data = {};
  }

  $onInit() {
    this.getMonitor(this.$stateParams.id);
  }

  getMonitor(id) {
    this.$http.get(`/api/monitors/${id}`).then(res => {
      this.data = res.data;
    });
  }

  update() {
    this.$http.put(`/api/monitors/${this.$stateParams.id}`, this.data).then(res => {
      this.$state.go('monitor');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/monitor/edit/edit.controller.js